/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.8 11.2H24v-.8c0-.4059-.0232-.8063-.0685-1.2C23.3818 4.4152 19.5848.6182 14.8.0685A10.5109 10.5109 0 0 0 13.6 0h-.8v11.2Zm2-9.115c3.6788.5263 6.5887 3.4362 7.1149 7.115H14.8V2.085Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.8 12.8h-9.6V3.2h-.8c-.4059 0-.8063.0232-1.2.0685C4.0215 3.8635 0 8.262 0 13.6 0 19.3438 4.6562 24 10.4 24c5.3379 0 9.7366-4.0215 10.3315-9.2.0453-.3937.0685-.7942.0685-1.2v-.8Zm-11.6 2h9.5149C18.1327 18.8708 14.6318 22 10.4 22 5.7608 22 2 18.2392 2 13.6c0-4.2318 3.1292-7.7327 7.2-8.315V14.8Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuAnalytics'
);
